// import prixAchatHT from '@/prixAchatHT.vue'
import {createStore}  from 'vuex'




 const store= createStore ({
    state(){
        return {
           count:1,
           etablissement:'DEPO',
           token_y2:'',
           date:'',
           barcodeFinded:'',
           articles: {},
           stockArticles:{},
           clients:[],
           waiting:false,
           marques:[],
           rayons:[],
           familles:[],
           sousFamilles:[],
           themes:[],
           dialogprixAchatHT:false,
           scanBarCode:'',
           countId:0,
           cab:0,
           numeroBon:1,
           signature:{exist:false,link:''},
           photoLinks:{exist:false,link:[],id:[]},
           articlesFripe:[],
           listeReceptions:{receptions:[],data:[]},
           codeFournisseur:{updated:false,code:'951263'},
           user:{},
           itemsEtablissemnt:{
              etabDEPO:{filliale:'DEPOT', etabliss:['DEPO','DWEB']},
              etabAD:{filliale:'AD', etabliss:['DEFEC','DEPAD','LITIG','NEGO','PHOTO','RECEP','TRANS','NGEXT']},
              etabReflex:{filliale:'Reflex', etabliss:['WEDI','WEBE','WENL','WETR','WOOM','WCAM','WAMZ']},
              etabEtrier:{filliale:'Etrier', etabliss:['CA24','VX05','PR25']},
              etabEdiBE:{filliale:'Edisac Belgique', etabliss:['BR08','NP19','GE22','OO10']},
              etabEdiFrNord:{filliale:'Edisac Nord', etabliss:['DK03','MN01','EN11','FT04','LI02','RO06',]},
              etabEdiPDC:{filliale:'Edisac PDC', etabliss:['AR09','CO18','HB21']},
              etabLc:{filliale:'Lonchamp', etabliss:['LO07']}
           },
           itemsPoles:[{code:'ACC' , libelle :'Pôle Accessoires'},	{code:'BAG' , libelle :'Pôle Bagages'},	{code:'BUS' , libelle :'Pôle Business'},	{code:'CHA' , libelle :'Pôle Chaussures'},	{code:'EMB' , libelle :'Pôle Emballages'},	{code:'LIF' , libelle :'Pôle Lifestyle'},	{code:'LUX' , libelle :'Pôle Luxe'},	{code:'MAR' , libelle :'Pôle Maroquinerie'},	{code:'MIN' , libelle :'Pôle Miniprix'},	{code:'NOS' , libelle :'Pôle Marque Propres'},	{code:'SCO' , libelle :'Pôle Scolaire'},	{code:'SEC' , libelle :'Pôle Second Life'},	{code:'SER' , libelle :'Pôle Services'},	{code:'VET' , libelle :'Pôle Vêtements'}],
           itemsAcheteurs:[{code:'ALD' , libelle :'ALICE'},	{code:'ARD' , libelle :'ARNAUD'},	{code:'ATR' , libelle :'AUTRE'},	{code:'AUT' , libelle :'AURELIE'},	{code:'EML' , libelle :'EMMA'},	{code:'JMC' , libelle :'JULIETTE'},	{code:'JVP' , libelle :'JASPER'},	{code:'LVK' , libelle :'LISA'},	{code:'MDD' , libelle :'MAUD'},	{code:'NOP' , libelle :'NOEMIE'},	{code:'SHP' , libelle :'SHIRLEY'},	{code:'VAS' , libelle :'VANESSA'}],
           isChangedCol:{ficheArticle:false,prixBase:false,promo:false,repart:false},
           itemColors:['AA-BLACK',	'AB-BLUE',	'AC-GREY',	'AD-MULTICOLOR',	'AE-WHITE',	'AF-BEIGE',	'AG-TAUPE',	'AH-CAMEL',	'AI-BROWN',	'AJ-RED',	'AK-ORANGE',	'AL-PINK',	'AM-PURPLE',	'AN-GREEN',	'AO-YELLOW'],
            // itemColors:[{title:'AA-BLACK',color:'black'},	{title:'AB-BLUE',color:'blue'},{title:'AC-GREY',color:'grey'}]
           component:'',
           frep:{
            title:{
                libelle:'BON DE COMMANDE',
                saison:'SPRING - SUMMER 2026',
                dateModif:'2025-09-25'
            },
            fournisseur:{
                date:'2025-10-01',
                nomClient:'Test',
                codeClient:'code_test',
                agent:'agent_test',
                codeAgent:'code_agent',
                libCommande:'testcommande',
                type_commande:'MEP',
                etablissement:'NEGO'
            },
            client:{
                enseigne:'enseigne',
                raisonSociale:'test',
                tvaSiret:'TVA_TEST',
                dateLivraison:'2025-10-15',
                adresseLiv:'Adresse liv',
                adresseFac:'Adresse Fac',
                contact:'contact_test',
                email:'emailtest',
                telephone:'0769',
                siteweb:'site',
                remarque:'Remarque'
            },
            fraisPort:20,
            remisePied1:10,
            remisePied2:0,
            articles:{
                
            },
            signature:{exist:false,link:'',file:''}
          },
          dateLivraisons:["20251013"],
          marque:"731",
          ip:''
        }
    },
    mutations: {
        setClientIP(state,payload){
          state.ip=payload
        } ,
        setTokenY2(state,payload){
          state.token_y2=payload
        } ,
        setDate(state,payload){
          state.date=payload
        },
        addmarque (state,payload){
          state.marque=payload
        },
        addDateLivraison (state,payload){
          state.dateLivraisons=payload
        },
        updateCodeFournisseur(state,payload){
          state.codeFournisseur={updated:!state.codeFournisseur.updated,code:payload}
        },
        addArticlesFrep (state,payload){
          state.frep.articles=payload
        },
        addSingleArticlesFrep (state,payload){
          
          // state.frep.articles=payload
          // if (!state.frep.articles[payload.code_marque]) {
          //   state.frep.articles[payload.code_marque] = {};
          // }
          
          // Initialiser code_theme si n'existe pas
          if (!state.frep.articles[payload.code_theme]) {
              state.frep.articles[payload.code_theme] = {};
          }
          
          // Initialiser reference_y2 si n'existe pas
          if (!state.frep.articles[payload.code_theme][payload.reference_y2]) {
              state.frep.articles[payload.code_theme][payload.reference_y2] = {};
          }
          
          // Ajouter l'article avec codebarre comme clé
          state.frep.articles[payload.code_theme][payload.reference_y2][payload.codebarre] = { ...payload };
        },
        updateComponent(state,payload){
          state.component=payload
        },
        updateIsChangedCol(state,payload){
          state.isChangedCol[payload.key]=payload.value
        },
        updateCAB(state,payload){
          state.cab=payload
        },
        addPhotos(state,payload){
          state.photoLinks.exist=payload.exist
          state.photoLinks.link.push(payload.links)
          state.photoLinks.id.push(payload.id)
        },
        deletePhotos(state,payload){
          state.photoLinks=payload
        },
        addSignature(state,payload){
          state.signature=payload
        },
        updateglobalID(state,payload){
          state.countId=payload
        },
        updateBarCode(state,payload){
          state.scanBarCode=payload
        },
        updateWaiting(state){
          state.waiting=!state.waiting
        },
        increment (state) {
          state.count++
        },
        addArticles (state,payload){
          state.articles=payload
        },
        stockArticles(state,payload){
          state.stockArticles=payload},
        updateCollection (state,payload){
             state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].collection=payload.collection.newcol
        },
        updateCollectionColor (state,payload){
          if(payload.collection){
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].collection=payload.collection.newcol
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=
          {...state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol,ficheArticle:payload.localChangedCol.ficheArticle}
          }else{
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=payload.localChangedCol
          }
          
        },
        updatePrix (state,payload){
          state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].vte_euro=payload.prix.newPrix
          state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=
          {...state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol,prixBase:payload.localChangedCol.prixBase}
          if(payload.prix.newRemise){
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=payload.prix.newPrix*(1-payload.prix.newRemise.split('%')[0]/100)
          }
          
        },
        updatePromo (state,payload){
          if (payload.prix.newPrix.toString().match(/%/)) {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=Number(state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].vte_euro*(1-payload.prix.newPrix.split('%')[0]/100)).toFixed(2)
          }else{
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=payload.prix.newPrix
          }
        },
        addTypePromo (state,payload){
          if (payload.prix.newType!='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].type_promo=payload.prix.newType
          }else if(payload.prix.newType=='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].type_promo=''
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=''
          }
        },
        updateRepart (state,payload){
          if (payload.repart.newRepart!='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].repart[payload.repart.mag]=payload.repart.newRepart
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=
          {...state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol,repart:payload.localChangedCol.repart}
          }
        },
        updateReference (state,payload){
          if (payload.data.value!='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key][payload.data.champs]=payload.data.value
          }
        },
        addmarques(state,payload){
          state.marques=payload
        },
        addBarcode(state,payload){
          state.barcodeFinded=payload
        },
        addRayons(state,payload){
          state.rayons=payload
        },
        addFamilles(state,payload){
          state.familles=payload
        },
        addSousFamilles(state,payload){
          state.sousFamilles=payload
        },
        addThemes(state,payload){
          state.themes=payload
        },
        addRowArticle(state,payload){
          state.articlesFripe.push(payload)
        },
        deleteArticles(state){
          state.articlesFripe=[]
        },
        deleteRowArticle(state,payload){
          state.articlesFripe=state.articlesFripe.filter(el=>el.id!=payload.id)
        },
        editRowArticle(state,payload){
          
          for(let item in state.articlesFripe){
            if(state.articlesFripe[item].id==payload.id){
              state.articlesFripe[item][payload.champs]=payload.value
              state.articlesFripe[item].id=state.articlesFripe[item].id.substring(0,10)+state.articlesFripe[item].libCouleur.substring(0,2)
              state.articlesFripe[item].refFourn=state.articlesFripe[item].prixPublicTTC+state.articlesFripe[item].refFourn.substring(state.articlesFripe[item].refFourn.length-5)
              state.articlesFripe[item].nomProduit=state.articlesFripe[item].refFourn
              state.articlesFripe[item].totalBrut=state.articlesFripe[item].qteCommande*state.articlesFripe[item].prixAchatHT,
              state.articlesFripe[item].coefBrut=state.articlesFripe[item].prixAchatHT&&state.articlesFripe[item].prixPublicTTC?Number(state.articlesFripe[item].prixPublicTTC/state.articlesFripe[item].prixAchatHT).toFixed(2):0,
              state.articlesFripe[item].totalPVpublic=state.articlesFripe[item].qteCommande&&state.articlesFripe[item].prixPublicTTC?state.articlesFripe[item].qteCommande*state.articlesFripe[item].prixPublicTTC:0
              //console.log(state.articlesFripe[item]);
            }
          }
          
        },
        editRowArticleFripe(state,payload){
          for(let item in state.articlesFripe){
            if(state.articlesFripe[item].id==payload.oldId){
              state.articlesFripe[item]=payload
            }
          }
        },
        editRowArticleReception(state,payload){
          for(let reception in state.listeReceptions.receptions){
            if(state.listeReceptions.receptions[reception].title==payload.title){
              for(let article in state.listeReceptions.receptions[reception].articles){
                if(state.listeReceptions.receptions[reception].articles[article].id==payload.id){
                  
                  if(payload.champs=='prixPublicTTC'){
                    state.listeReceptions.receptions[reception].articles[article].prixPublicTTC=payload.value
                    state.listeReceptions.receptions[reception].articles[article].prixAchatHT=(payload.value/1.8).toFixed(1)
                  }else if(payload.champs=='prixAchatHT'){
                    state.listeReceptions.receptions[reception].articles[article].prixAchatHT=payload.value
                    state.listeReceptions.receptions[reception].articles[article].prixPublicTTC=(payload.value*1.8).toFixed(1)
                  } else if(payload.champs=='grade' || payload.champs=='prixAchatOrigine'){
                    // console.log(state.listeReceptions.receptions[reception].articles[article]);
                    if(payload.champs=='prixAchatOrigine'){
                      state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine=payload.value
                    }else if(payload.champs=='grade'){
                      state.listeReceptions.receptions[reception].articles[article].grade=payload.value
                    }
                    
                    
                    switch (state.listeReceptions.receptions[reception].articles[article].grade.split('-')[0]){
                      case "A":   state.listeReceptions.receptions[reception].articles[article].prixAchatHT= Number(state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine*0.35).toFixed(1);
                        state.listeReceptions.receptions[reception].articles[article].grade='A-Excellent état'
                      break
                      case "B":  state.listeReceptions.receptions[reception].articles[article].prixAchatHT= Number(state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine*0.30).toFixed(1)
                        state.listeReceptions.receptions[reception].articles[article].grade='B-très bon état'
                      break
                      case "C": state.listeReceptions.receptions[reception].articles[article].prixAchatHT= Number(state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine*0.25).toFixed(1)
                        state.listeReceptions.receptions[reception].articles[article].grade='C-Bon état'
                      break 
                    }
                    state.listeReceptions.receptions[reception].articles[article].prixPublicTTC=(1.8*state.listeReceptions.receptions[reception].articles[article].prixAchatHT).toFixed(1)
                  }
                  state.listeReceptions.receptions[reception].articles[article].totalBrut=state.listeReceptions.receptions[reception].articles[article].prixAchatHT*state.listeReceptions.receptions[reception].articles[article].qteCommande
                }
              }
            }
          }
        },
        terminerReception(state,payload){
          for(let reception in state.listeReceptions.receptions){
            if(state.listeReceptions.receptions[reception].title==payload.title){
              state.listeReceptions.receptions[reception]={...state.listeReceptions.receptions[reception],termine:'true'}
            }
          }
        }
        ,
        addClient(state,payload){
          state.clients=payload
        },
        addNumBon(state,payload){
          state.numeroBon=payload
        },
        updateDialogprixAchatHT(state,payload){
          state.dialogprixAchatHT=payload
        },
        updatephoto(state,payload){
          state.photoLinks.exist=payload
        },
        addListeReceptions(state,payload){
          state.listeReceptions=payload
        },
        deletePhoto(state,payload){
          state.photoLinks.id=state.photoLinks.id.filter(el=>el!=payload)
        },
        addUser(state,payload){
          state.user=payload
        },
        addReception(state,payload){
          state.articlesFripe=payload
        },
        deletePromo(state,payload){
          for (let art in state.articles[payload.marque][payload.theme][payload.reference]){
            state.articles[payload.marque][payload.theme][payload.reference][art].type_promo=''
            state.articles[payload.marque][payload.theme][payload.reference][art].prix_promo=''
          }
        }
      },
    getters:{},
    actions :{}
})
export default store